import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=6bfa4da9&scoped=true&"
import script from "./Title.vue?vue&type=script&lang=js&"
export * from "./Title.vue?vue&type=script&lang=js&"
import style0 from "./Title.vue?vue&type=style&index=0&id=6bfa4da9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfa4da9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bfa4da9')) {
      api.createRecord('6bfa4da9', component.options)
    } else {
      api.reload('6bfa4da9', component.options)
    }
    module.hot.accept("./Title.vue?vue&type=template&id=6bfa4da9&scoped=true&", function () {
      api.rerender('6bfa4da9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/Global/Title.vue"
export default component.exports